export const PORTUGAL = { lat: 38.726466, lng: -9.2362514 }
export const DEFAULT_REGION = 'PT'
export const DEFAULT_LOCALE = 'pt-PT'
export const GOOGLE_MAPS_API_KEY =
  process.env['GOOGLE_MAPS_API_KEY'] ??
  'AIzaSyC0H1QwTGaD29L7TAF00XPO_fY0LwgPdTs'
